import Main from 'app/PemetaanKompetensiPage/pages/RencanaPengembanganDiri/Main'

const PageRencanaPengembanganDiri = () => {
  return <Main />
}

PageRencanaPengembanganDiri.layoutOpts = {
  className: 'text-default bg-white !h-full min-h-screen',
}

export default PageRencanaPengembanganDiri
